<template>
  <h6>{{ member | firstletter }}</h6>
</template>

<script>
  export default {
    name: 'Lid',
    props: {
      member: {
        type: String,
        required: false,
        default: '',
      }
    }
  };
</script>

<style scoped>

</style>
